module.exports = __webpack_public_path__ + "img/danwei.1f0edffe.svg";